// 效期类型
export const EXPIRATION_TYPE = {
    // 默认
    DEFAULT: 0,
    // 半天效期
    HALF_DAY: 1,
    // 小时批次
    HOUR: 2,
    // 1/4天批次
    QUARTER_DAY: 3,
    // 1/3天批次
    THIRD_DAY: 4,
};

export const EXPIRATION_TYPE_MAP = {
    0: '默认',
    1: '半天效期',
    2: '小时批次',
    3: '1/4天批次',
    4: '1/3天批次',
};
// 预采类型
export const PLAN_TYPE = {
    // 今日预采
    T0: 0,
    // 明日预采
    T1: 1,
};
